// Added By mlveda--
// Custom Owl - carousel Script apply only on responsive script start
$(window).resize(function(){
  OwlCarouselInit();
});

$(document).ready(function() {
  OwlCarouselInit();
});
function OwlCarouselInit() {
    if (window.matchMedia("(max-width: 767px)").matches) {
        $('#testimonial-carousel').owlCarousel({
            loop: true,
            margin: 0,
            nav: true,
            items: 1,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
        });

        $('.customer-opinion-carousel').each(function () {
            $(this).owlCarousel({
                loop: true,
                margin: 10,
                nav: true,
                items: 1,
                dots: false,
                mouseDrag: true,
                touchDrag: true,
            });
        });
    } else {
        $('#testimonial-carousel').owlCarousel('destroy');
        $('.customer-opinion-carousel').each(function () {
            $(this).owlCarousel('destroy');
        });
    }
}
// Custom Owl - carousel Script apply only on responsive script end
// Custom Accordian Start
document.addEventListener("DOMContentLoaded", function(event) {
   $(".accordian-main-box .accordian-item").click(function() {
    // $(this).addClass('open').siblings().removeClass('open');
      $(this).toggleClass('open').siblings().removeClass('open');
  });
});
// Custom Accordian End